import { debounce } from '../functions.js';

document.addEventListener('DOMContentLoaded', () => {
    const $mainElement = document.querySelector('main');
    const $menuElement = document.getElementById('mainmenu');
    const $navbarBurger = document.getElementById('navbar-burger');
    const $navbarBurgerLabel = $navbarBurger?.getElementsByClassName('hamburger-label')[0];
    const navbarBurgerLabelText = typeof $navbarBurgerLabel !== 'undefined' ? $navbarBurgerLabel.innerHTML : '';
    const $searchTriggers = document.querySelectorAll('[href="#modal-search"][data-action="collapse"]');
    const mq = window.matchMedia("(min-width: 1008px)");

    if ($mainElement && $navbarBurger && $menuElement) {
        const closeMenu = () => {
            $navbarBurger.classList.remove('is-active');
            $menuElement.classList.remove('is-active');
            $mainElement.classList.remove('has-opacity-medium');

            if (typeof $navbarBurgerLabel !== 'undefined') {
                $navbarBurgerLabel.textContent = navbarBurgerLabelText;
            }
        };

        $navbarBurger.addEventListener('click', () => {
            $mainElement.classList.toggle('has-opacity-medium');
            $navbarBurger.classList.toggle('is-active');
            $menuElement.classList.toggle('is-active');

            if (typeof $navbarBurgerLabel !== 'undefined' && $navbarBurgerLabel.dataset.closetext) {
                if ($menuElement.classList.contains('is-active')) {
                    $navbarBurgerLabel.textContent = $navbarBurgerLabel.dataset.closetext;
                }
                else {
                    $navbarBurgerLabel.textContent = navbarBurgerLabelText;
                }
            }
        });

        const handleResize = () => {
            if (mq.matches) {
                closeMenu();
            }
        }

        const debouncedHandleResize = debounce(handleResize, 50);

        window.addEventListener('resize', debouncedHandleResize);

        document.addEventListener('click', (event) => {
            let isClickInside = false;

            if ($menuElement.contains(event.target) || $navbarBurger.contains(event.target)) {
                isClickInside = true;
            }

            if (!isClickInside) {
                closeMenu();
            }
        });

        $searchTriggers.forEach($searchTrigger => {
            $searchTrigger.addEventListener('click', () => {
                closeMenu();
            });
        });
    }
});
